import { Box, SidePanel, Text } from "@wix/design-system";
import classNames from "classnames";
import React from "react";
import { PANEL_HEADER_ID } from "./../consts.js";
import classes from "./panel-header-scss.js";
const PanelHeader = ({ title, subtitle, className }) => {
  return /* @__PURE__ */ React.createElement("div", { "data-drag-handler": "true" }, /* @__PURE__ */ React.createElement(
    SidePanel.Header,
    {
      showDivider: true,
      className: classNames(classes.header, className),
      title: /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Text, { id: PANEL_HEADER_ID, placement: "auto", as: "h2", size: "medium", weight: "bold" }, title)),
      subtitle
    }
  ));
};
export {
  PanelHeader
};
//# sourceMappingURL=panel-header.js.map
